import { z } from 'zod';

import { SCHEMAS } from './base';

export const outletInfoSchema = z.object({
  name: SCHEMAS.outletName,
  street: SCHEMAS.outletStreet,
  city: SCHEMAS.outletCity,
  state: SCHEMAS.outletState,
  country: SCHEMAS.outletCountry,
  zipcode: SCHEMAS.outletZipcode,
  fssaiLicenseNumber: SCHEMAS.outletFssaiLicenseNumber,
  currency: z.string().optional(),
  copyMenuFromOutletId: z.string().optional(),
});

export type OutletInfoData = z.infer<typeof outletInfoSchema>;

export const outletDefaultValues: OutletInfoData = {
  name: '',
  street: '',
  city: '',
  state: '',
  country: 'IN',
  zipcode: '',
  fssaiLicenseNumber: '',
  currency: 'INR',
  copyMenuFromOutletId: '',
};
